import { Spinner, Text } from '@viapeople/components'
import {
	CartesianGrid,
	ReferenceLine,
	ResponsiveContainer,
	Scatter,
	ScatterChart,
	Tooltip,
	XAxis,
	YAxis,
	ZAxis,
} from 'recharts'

interface ScatterPoint {
	userId: string
	employeeName: string
	performanceRating: number
	threeSixtyAvg: number
	department: string | null
}

interface Props {
	data: ScatterPoint[] | undefined
	loading?: boolean
}

export function ThreeSixtyVsPerformanceScatter({ data, loading }: Props) {
	if (loading) {
		return (
			<div data-testid='scatter-360-loading' className='flex items-center justify-center h-64'>
				<Spinner />
			</div>
		)
	}
	if (!data || data.length === 0) {
		return (
			<div data-testid='scatter-360-empty' className='flex items-center justify-center h-64 text-neutral-500'>
				No 360 data available for the current filters.
			</div>
		)
	}

	return (
		<div data-testid='scatter-360' className='w-full'>
			<Text variant='small' weight='semibold' className='mb-2'>
				360 Score vs Performance Rating
			</Text>
			<ResponsiveContainer width='100%' height={360}>
				<ScatterChart margin={{ top: 16, right: 32, left: 16, bottom: 32 }}>
					<CartesianGrid strokeDasharray='3 3' stroke='#e5e7eb' />
					<XAxis
						type='number'
						dataKey='performanceRating'
						name='Performance Rating'
						domain={[0, 5]}
						tickCount={6}
						tick={{ fontSize: 12 }}
						label={{ value: 'Performance', position: 'insideBottom', offset: -8, fontSize: 11 }}
					/>
					<YAxis
						type='number'
						dataKey='threeSixtyAvg'
						name='360 Avg'
						domain={[0, 5]}
						tickCount={6}
						tick={{ fontSize: 12 }}
						label={{ value: '360 Avg', angle: -90, position: 'insideLeft', offset: 8, fontSize: 11 }}
					/>
					<ZAxis range={[60, 60]} />
					<ReferenceLine x={4} stroke='#9ca3af' strokeDasharray='3 3' />
					<ReferenceLine y={4} stroke='#9ca3af' strokeDasharray='3 3' />
					<Tooltip
						cursor={{ strokeDasharray: '3 3' }}
						contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #e5e7eb' }}
						formatter={(value) => (typeof value === 'number' ? value.toFixed(2) : String(value ?? ''))}
						labelFormatter={() => ''}
					/>
					<Scatter data={data} fill='#0ea5e9' />
				</ScatterChart>
			</ResponsiveContainer>
		</div>
	)
}
